import { render } from "./openXiaoChengXu.vue?vue&type=template&id=664cebb6"
import script from "./openXiaoChengXu.vue?vue&type=script&lang=js"
export * from "./openXiaoChengXu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
